import React from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";

import Diferenciais from "@src/views/Diferenciais";

const CardInfo = () => {
  const { t } = useTranslation();

  return (
    <div id="containerPrincipal">
      <Diferenciais />
    </div>
  );
};

export { CardInfo };
